function SearchSuggestController() {
	const inputSelector = 'input[data-search-suggest]'
	const focusSelector = '.js-search-suggest-focus'
	const itemSelector = '[data-suggestion-link]'

	this.init = function () {
		jQuery('form[data-suggest]').each(function () {
			const $form = jQuery(this)

			if ($form.data('searchSuggestInitialized')) {
				return
			}

			const $input = $form.find(inputSelector).first()
			if ($input.length === 0) {
				return
			}

			const $container = $form.closest('.search').length ? $form.closest('.search') : $form
			const $suggestions = $container.find('.search__suggestions')
			const $suggestionList = $suggestions.find('ul')
			let debounceTimer = null
			let abortController = null
			let activeIndex = -1

			$form.data('searchSuggestInitialized', true)

			const hideSuggestions = function () {
				activeIndex = -1
				$suggestionList.empty()
				$suggestions.hide()
				$container.removeClass('autocomplete-active')
			}

			const renderSuggestions = function (items) {
				$suggestionList.empty()
				activeIndex = -1

				if (!items.length) {
					hideSuggestions()
					return
				}

				items.forEach(function (item, index) {
					const $entry = jQuery('<li class="search__suggestion-item"></li>')
					const $link = jQuery('<a class="search__suggestion-link"></a>')
					$link.attr('href', item.link || '#')
					$link.attr('data-suggestion-link', '1')
					$link.attr('data-index', index)
					$link.html(item.title || '')

					if (!item.link) {
						$link.attr('role', 'button')
					}

					$entry.append($link)
					$suggestionList.append($entry)
				})

				$suggestions.show()
				$container.addClass('autocomplete-active')
			}

			const normalizeResponse = function (response) {
				if (!response) {
					return []
				}

				if (Array.isArray(response.documents)) {
					return response.documents
						.filter(function (item) {
							return item && item.title
						})
						.map(function (item) {
							return {
								title: item.title,
								link: item.link || '',
							}
						})
				}

				if (response.suggestions && typeof response.suggestions === 'object') {
					return Object.keys(response.suggestions)
						.filter(function (title) {
							return title && title.trim() !== ''
						})
						.map(function (title) {
							return {
								title: title,
								link: '',
							}
						})
				}

				return []
			}

			const fetchSuggestions = function (query) {
				if (abortController) {
					abortController.abort()
				}

				abortController = new AbortController()
				const url = new URL($form.data('suggest'), window.location.origin)
				url.searchParams.set('queryString', query)

				fetch(url.toString(), {
					signal: abortController.signal,
					headers: {
						Accept: 'application/json',
					},
				})
					.then(function (response) {
						if (!response.ok) {
							throw new Error('Suggestion request failed')
						}

						return response.json()
					})
					.then(function (response) {
						renderSuggestions(normalizeResponse(response))
					})
					.catch(function (error) {
						if (error.name !== 'AbortError') {
							hideSuggestions()
						}
					})
			}

			$form.on('submit', function (event) {
				if ($input.val().trim() === '') {
					event.preventDefault()
					$input.trigger('focus')
				}
			})

			$input.on('input', function () {
				const query = $input.val().trim()

				window.clearTimeout(debounceTimer)

				if (query.length < 2) {
					hideSuggestions()
					return
				}

				debounceTimer = window.setTimeout(function () {
					fetchSuggestions(query)
				}, 150)
			})

			$input.on('keydown', function (event) {
				const $items = $suggestionList.find(itemSelector)
				if ($items.length === 0) {
					return
				}

				if (event.key === 'ArrowDown') {
					event.preventDefault()
					activeIndex = (activeIndex + 1) % $items.length
				} else if (event.key === 'ArrowUp') {
					event.preventDefault()
					activeIndex = activeIndex <= 0 ? $items.length - 1 : activeIndex - 1
				} else if (event.key === 'Enter' && activeIndex >= 0) {
					event.preventDefault()
					$items.eq(activeIndex).get(0).click()
					return
				} else if (event.key === 'Escape') {
					hideSuggestions()
					return
				} else {
					return
				}

				$items.removeClass('is-active')
				$items.eq(activeIndex).addClass('is-active')
			})

			$form.on('blur', inputSelector, function () {
				window.setTimeout(function () {
					hideSuggestions()
				}, 200)
			})

			$suggestionList.on('mousedown', itemSelector, function (event) {
				if (!jQuery(this).attr('href') || jQuery(this).attr('href') === '#') {
					event.preventDefault()
					$form.trigger('submit')
				}
			})
		})
	}
}

jQuery(document).ready(function () {
	const searchSuggestController = new SearchSuggestController()
	searchSuggestController.init()
})
